import { AdminEditBusinessScreen } from '@/features/admin/screens/admin-edit-business-screen';

export default function AdminEditBusinessRoute() {
  return <AdminEditBusinessScreen />;
}
